import React, { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import numeral from 'numeraljs'
// import classNames from 'classnames'

// import styles from '../component-styles/bulk-delete-modal.module.scss'
// import {
//   uploadBulkTemplate,
// } from '../api-client/track-client'
import { deleteCampaignCodesAsync } from '../store/actions'
import Heading from './heading'
import Modal, { ModalHead, ModalBody, ModalFooter } from './modal'
import ConfirmationButtons from './confirmation-buttons'

interface Props {
  setShowModal: (status: boolean) => void
  selectedCodes: string[]
  selectedCodesCanDelete: string[]
  onDelete: (codesNotDeleted: string[]) => void
  isAdmin: boolean
}

export default function BulkDeleteModal({
  setShowModal,
  selectedCodes,
  selectedCodesCanDelete,
  onDelete,
  isAdmin,
}: Props): React.ReactElement | null {
  const dispatch = useDispatch()

  // const [error, setError] = useState('')

  const onDeleteAction = async (): Promise<void> => {
    const codesNotDeleted = selectedCodes.filter((cId) => {
      const isDeleted = selectedCodesCanDelete.indexOf(cId) !== -1
      return !isDeleted
    })
    onDelete(codesNotDeleted)
    dispatch(deleteCampaignCodesAsync(selectedCodesCanDelete))
  }

  // {error && (
  //      <p
  //        className={styles.error}
  //        dangerouslySetInnerHTML={{ __html: error }}
  //      />
  //    )}

  const message = useMemo(() => {
    if (!isAdmin && selectedCodes.length !== selectedCodesCanDelete.length) {
      if (selectedCodesCanDelete.length === 0) {
        return `You can only delete campaign links that you have created. Contact an admin user to delete campaign links created by other users.`
      }
      return `You can only delete campaign links that you have created, would you like to delete your ${numeral(
        selectedCodesCanDelete.length,
      ).format('0,0')} link${selectedCodesCanDelete.length > 1 ? 's' : ''}?`
    }
    return `Are you sure you want to delete the ${numeral(
      selectedCodes.length,
    ).format('0,0')} selected campaign link${
      selectedCodes.length > 1 ? 's' : ''
    }?`
  }, [isAdmin, selectedCodes, selectedCodesCanDelete])

  const isDisabled = !isAdmin && selectedCodesCanDelete.length === 0

  return (
    <Modal
      active
      toggleActive={() => {
        setShowModal(false)
      }}
      narrow
      type="white"
    >
      <ModalHead>
        <Heading type={3} align="left">
          Confirm deletion
        </Heading>
      </ModalHead>
      <ModalBody>
        <p>{message}</p>
      </ModalBody>
      <ModalFooter>
        <ConfirmationButtons
          hideDisabled
          disabled={isDisabled}
          type="simple"
          onYes={(): void => {
            onDeleteAction()
            setShowModal(false)
          }}
          onNo={(): void => {
            setShowModal(false)
          }}
          yesLabel="Delete"
          noLabel="Go back"
        />
      </ModalFooter>
    </Modal>
  )
}
